import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda} from "@commons/core.slice";
import AziendaNavContainer from "../../../features/azienda/AziendaNavContainer";
import React, {useEffect, useState} from "react";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {LavoratoreBar} from "../../../features/lavoratore/LavoratoreBar";
import {useLazyGetLavoratoreQuery, useUpdateLavoratoreMutation} from "@commons/features/lavoratore/lavoratore.api";
import {Tab} from "@headlessui/react";
import {useEditor} from "../../../core/editor";
import GeneralitaLavoratoreEditor from "./form";
import UploadFotoLavoratore from "../foto/Lavoratori.foto";
import {toastAsError} from "@utilities/toastAsError";
import {useLavoratore} from "@commons/hooks/useLavoratoreHR";
import {useFotoLavoratore} from "@hooks/useFotoLavoratore";

const LavoratoriGeneralitaPage: React.FC<{}> = () => {
    const azienda: AziendaRecord | null = useAppSelector(selectAzienda);
    //const contratto: Lavoratore | null = useAppSelector(selectLavoratore);
    const contratto: LavoratoreRecord | null = useLavoratore(toastAsError);

    const [tabIndex, setTabIndex] = useState<number>(0);
    //const {data} = useGetLavoratoreQuery({idDip: contratto ? contratto.id : 0}, {skip: contratto === null});

    const [getTrigger, result, promiseInfo] = useLazyGetLavoratoreQuery();
    const [updateTrigger, updateResult] = useUpdateLavoratoreMutation();
    const {resource, cancel, URI, edit, saveResource} = useEditor<LavoratoreRecord>(undefined, undefined, updateTrigger)

    useEffect(() => {
        if (contratto) {
            getTrigger({idDip: contratto.id}, false).then((res) => {
                if (res && res.isSuccess) {
                    edit(res.data, res.data.URI!);
                } else if (res.isError) {
                    if ('data' in res.error) {
                        // @ts-ignore
                        const message = res.error.data.message;
                        toastAsError(message);
                    } else
                        toastAsError("Errore generico!");
                }
            })
        }
    }, [contratto])
    const {srcFoto, refetch} = useFotoLavoratore(contratto);
    //console.log(srcFoto);
    return (<>
        <AziendaNavContainer>
            {azienda && <>
                <LavoratoreBar azienda={azienda} lavoratoreSrcFoto={srcFoto}>

                    <Tab.Group selectedIndex={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <Tab.List className="tab-list">
                            <Tab className="tab">Propriet&agrave;</Tab>
                            <Tab disabled={true} className="tab">Anagrafica</Tab>
                            <Tab className="tab">Gestione foto</Tab>
                            <Tab disabled={true} className="tab">Extra-CE</Tab>
                        </Tab.List>
                        <Tab.Panels className="tab-panels">
                            <Tab.Panel>
                                {resource && <div className="p-3">
                                    {/*<p className="text-xs">URI: {resource.URI}</p>*/}
                                    <GeneralitaLavoratoreEditor
                                        defaultValues={{} as LavoratoreRecord}
                                        resource={resource}
                                        srcFoto={srcFoto}
                                        onCancel={() => {
                                            edit(resource, resource.URI!);
                                        }}
                                        onSubmit={saveResource}
                                    ></GeneralitaLavoratoreEditor>
                                </div>}
                            </Tab.Panel>
                            <Tab.Panel/>
                            <Tab.Panel>
                                {resource && <div className="p-3">
                                    {/*<p className="text-xs">URI: {resource.URI}</p>*/}
                                    <UploadFotoLavoratore refetch={refetch}
                                                          resource={resource}
                                    ></UploadFotoLavoratore>
                                </div>}
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </LavoratoreBar>
            </>}
        </AziendaNavContainer>
    </>)
}
export default LavoratoriGeneralitaPage;